import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { RequestUser, UserCustomAttribute } from 'shared-types';

const canUserCustomAttributeBeViewedInSettings = (
  user: RequestUser,
  userCustomAttribute: UserCustomAttribute
) => {
  if (
    user?.roles.includes('superadmin') &&
    userCustomAttribute.permissions?.viewSettings.superadmin.value
  ) {
    return userCustomAttribute.permissions.viewSettings.superadmin.conditions
      ?.length
      ? attributesConditionsMatch({
          conditions:
            userCustomAttribute.permissions.viewSettings.superadmin.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  if (
    user?.roles.includes('admin') &&
    user?.permissions?.includes('edit-user-custom-attributes') &&
    !user.roles.includes('superadmin') &&
    userCustomAttribute.permissions?.viewSettings.admin.value
  ) {
    return userCustomAttribute.permissions.viewSettings.admin.conditions?.length
      ? attributesConditionsMatch({
          conditions:
            userCustomAttribute.permissions.viewSettings.admin.conditions,
          user,
          customAttributeValues: user.customAttributes
        })
      : true;
  }

  return false;
};

export default canUserCustomAttributeBeViewedInSettings;
